module.exports = __webpack_public_path__ + "img/loginPasscodeOrBiometrics01.png";